<button
  mat-icon-button
  id="notifications-button"
  [attr.aria-label]="'NotificationBell.Title' | translate: locale.language"
  [matMenuTriggerFor]="notificationsMenu"
  [matBadge]="notificationService.unreadCount()"
  [matBadgeHidden]="notificationService.unreadCount() === 0"
  matBadgeColor="warn"
  matBadgeSize="small"
  style="color: white">
  <mat-icon>notifications</mat-icon>
</button>

<mat-menu #notificationsMenu="matMenu" xPosition="before" yPosition="below" class="notifications-panel">
  <div class="notifications-header" (keydown.enter)="$event.stopPropagation()" (click)="$event.stopPropagation()">
    <span class="notifications-title">{{ 'NotificationBell.Title' | translate: locale.language }}</span>
    @if (notificationService.unreadCount() > 0) {
      <button mat-button color="primary" (click)="notificationService.markAllRead()">
        {{ 'NotificationBell.MarkAllRead' | translate: locale.language }}
      </button>
    }
  </div>
  <mat-divider></mat-divider>
  @if (notificationService.generalNotifications().length === 0) {
    <div class="notifications-empty">{{ 'NotificationBell.NoNotifications' | translate: locale.language }}</div>
  }
  @for (n of notificationService.generalNotifications(); track n.id) {
    <div
      class="notification-item"
      [class.unread]="!n.read"
      (keydown.enter)="onNotificationClick(n)"
      (click)="onNotificationClick(n)">
      <div class="notification-item-body">
        <span class="notification-item-title">{{ n.title }}</span>
        <span class="notification-item-message">{{ n.message }}</span>
      </div>
      @if (!n.persistent) {
        <button
          mat-icon-button
          class="notification-dismiss"
          [attr.aria-label]="'NotificationBell.Dismiss' | translate: locale.language"
          (click)="$event.stopPropagation(); notificationService.dismiss(n.id)">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  }
</mat-menu>
